import { computed, ref } from 'vue';

// Module singleton (see useResults). Persists in localStorage as a personal
// display preference - deliberately not in the shareable querystring.

const STORAGE_KEY = 'listing-view';
const VIEW_KEYS = ['list', 'both', 'map'];
const DEFAULT_VIEW = 'both';

const storedView = () => {
  try {
    const value = window.localStorage.getItem(STORAGE_KEY);
    return VIEW_KEYS.includes(value) ? value : DEFAULT_VIEW;
  } catch {
    return DEFAULT_VIEW;
  }
};

const preferredView = ref(storedView());

// 900px is where the split layout stops sitting side by side (_listing-cards.scss),
// so below it 'both' is not offered and falls back to the list. The preference is
// kept untouched, which brings the split back on resize without a fresh choice.
const splitMediaQuery = window.matchMedia('(min-width: 901px)');
const splitAvailable = ref(splitMediaQuery.matches);

splitMediaQuery.addEventListener('change', (event) => {
  splitAvailable.value = event.matches;
});

const view = computed(() => (
  preferredView.value === 'both' && !splitAvailable.value ? 'list' : preferredView.value
));

export const useView = () => ({
  view,
  splitAvailable,
  setView: (key) => {
    preferredView.value = key;
    try {
      window.localStorage.setItem(STORAGE_KEY, key);
    } catch {
      // private mode/quota: the choice simply does not persist
    }
  }
});
